import { EMPTY } from 'rxjs';
import { flog } from '@zambezi/caballo-vivo';
export default function createHelpNowChat$(brand) {
  var site = '49343281';
  if (process.env.REACT_APP_DISABLE_HELP_NOW) {
    return EMPTY.pipe(flog('Help Now chat not loaded (disabled by env variable)'));
  } else {
    loadHelpNow(site, brand);
    return EMPTY.pipe(flog('Help Now chat loaded'));
  }
}

/* eslint-disable */
function loadHelpNow(site, brand) {
  // *** First script in the page (originally was js/le-mtagconfig.js)
  ;
  window.lpTag = window.lpTag || {}, 'undefined' == typeof window.lpTag._tagCount ? (window.lpTag = {
    site: site,
    section: lpTag.section || '',
    tagletSection: lpTag.tagletSection || null,
    autoStart: lpTag.autoStart !== !1,
    ovr: lpTag.ovr || {},
    _v: '1.7.0',
    _tagCount: 1,
    protocol: 'https:',
    events: {
      bind: function bind(t, e, i) {
        lpTag.defer(function () {
          lpTag.events.bind(t, e, i);
        }, 0);
      },
      trigger: function trigger(t, e, i) {
        lpTag.defer(function () {
          lpTag.events.trigger(t, e, i);
        }, 1);
      }
    },
    defer: function defer(t, e) {
      0 == e ? (this._defB = this._defB || [], this._defB.push(t)) : 1 == e ? (this._defT = this._defT || [], this._defT.push(t)) : (this._defL = this._defL || [], this._defL.push(t));
    },
    load: function load(t, e, i) {
      var n = this;
      setTimeout(function () {
        n._load(t, e, i);
      }, 0);
    },
    _load: function _load(t, e, i) {
      var n = t;
      t || (n = this.protocol + '//' + (this.ovr && this.ovr.domain ? this.ovr.domain : 'lptag.liveperson.net') + '/tag/tag.js?site=' + this.site);
      var a = document.createElement('script');
      a.setAttribute('charset', e ? e : 'UTF-8'), i && a.setAttribute('id', i), a.setAttribute('src', n), document.getElementsByTagName('head').item(0).appendChild(a);
    },
    init: function init() {
      ;
      this._timing = this._timing || {}, this._timing.start = new Date().getTime();
      var t = this;
      window.attachEvent ? window.attachEvent('onload', function () {
        t._domReady('domReady');
      }) : (window.addEventListener('DOMContentLoaded', function () {
        t._domReady('contReady');
      }, !1), window.addEventListener('load', function () {
        t._domReady('domReady');
      }, !1)), 'undefined' == typeof window._lptStop && this.load();
    },
    start: function start() {
      this.autoStart = !0;
    },
    _domReady: function _domReady(t) {
      this.isDom || (this.isDom = !0, this.events.trigger('LPT', 'DOM_READY', {
        t: t
      })), this._timing[t] = new Date().getTime();
    },
    vars: lpTag.vars || [],
    dbs: lpTag.dbs || [],
    ctn: lpTag.ctn || [],
    sdes: lpTag.sdes || [],
    ev: lpTag.ev || []
  }, lpTag.init()) : window.lpTag._tagCount += 1;

  // *** Second script in the page
  // REQUIRED - Tag initialisation - include this on every page
  window.lpTag = window.lpTag || {};
  lpTag.sdes = lpTag.sdes || [];

  // *** Third script in the page (originally was js/lpSectionFunctions.js)
  // ** Section functions **
  // ** Required on all pages a chat might start from **
  window.lpSection = window.lpSection || {};

  // Looks at values assigned to properties, outputs array to be used by lpTag.section
  lpSection.createSection = function () {
    var output = [];
    if (lpSection.brand) {
      output.push('brand:' + lpSection.brand);
    }
    if (lpSection.lob) {
      output.push('lob:' + lpSection.lob);
    }
    if (lpSection.siteLocation) {
      output.push('location:' + lpSection.siteLocation);
    }
    if (lpSection.pageId) {
      output.push('pageid:' + lpSection.pageId);
    }
    if (lpSection.sectionTree) {
      output.push('sectiontree:' + lpSection.sectionTree);
    }
    return output;
  };

  // Looks at values assigned to properties, outputs value to be used by lpTag.tagletSection
  lpSection.createTagletSection = function () {
    var output = '';
    if (lpSection.brand) {
      if (lpSection.siteLocation !== '') {
        output = lpSection.brand + '-' + lpSection.siteLocation;
      } else {
        output = lpSection.brand;
      }
    }
    return output;
  };

  // *** Fourth script in the page
  window.lpSection = window.lpSection || {};
  lpSection.brand = brand.get('helpNowBrand');
  lpSection.lob = 'personal-service';
  lpSection.siteLocation = 'ob-consent';
  lpSection.pageId = 'XX01';

  // Generate section/tagletSection
  lpTag.section = lpSection.createSection();
  lpTag.tagletSection = lpSection.createTagletSection();
}
/* eslint-enable */